<template>
  <div class="honor">
    <div class="honorCenter">
      <div
        class="four wow animated fadeInUp"
        data-wow-duration="1s"
        data-wow-delay="0s"
      >
        品牌荣誉
      </div>
      <div
        class="yi wow animated fadeInUp"
        data-wow-duration="1.5s"
        data-wow-delay="0s"
      ></div>
      <div class="Bighonor">
        <div
          class="one wow animated fadeInUp"
          data-wow-duration="1.5s"
          data-wow-delay=".5s"
        >
          <img src="../../assets/about/图层 14.png" alt="" />
          <p class="p1">荣誉名称</p>
          <p class="p2">文字介绍文字介绍</p>
        </div>
        <div
          class="one wow animated fadeInUp"
          data-wow-duration="1s"
          data-wow-delay=".5s"
        >
          <img src="../../assets/about/图层 14.png" alt="" />
          <p class="p1">荣誉名称</p>
          <p class="p2">文字介绍文字介绍</p>
        </div>
        <div
          class="one wow animated fadeInUp"
          data-wow-duration="1s"
          data-wow-delay=".5s"
        >
          <img src="../../assets/about/图层 14.png" alt="" />
          <p class="p1">荣誉名称</p>
          <p class="p2">文字介绍文字介绍</p>
        </div>
        <div
          class="one wow animated fadeInUp"
          data-wow-duration="1s"
          data-wow-delay=".5s"
        >
          <img src="../../assets/about/图层 14.png" alt="" />
          <p class="p1">荣誉名称</p>
          <p class="p2">文字介绍文字介绍</p>
        </div>
        <div
          class="one wow animated fadeInUp"
          data-wow-duration="1s"
          data-wow-delay=".5s"
        >
          <img src="../../assets/about/图层 14.png" alt="" />
          <p class="p1">荣誉名称</p>
          <p class="p2">文字介绍文字介绍</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";

export default {
  data() {
    return {};
  },
  mounted() {
    window.addEventListener("scroll", this.windowScroll);
    this.$parent.color = `#000`;
    this.$parent.backgroundColor = "#fff";
    let wow = new WOW({
      boxClass: "wow", //需要执行动画的元素的 class
      animateClass: "animated", //animation.css 动画的 class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备上执行动画
      live: true, //异步加载的内容是否有效
    });
    wow.init();
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.honor {
  width: 100%;
  .honorCenter {
    width: 1440px;
    margin: 0 auto;
  }
  .four {
    width: 123px;
    height: 30px;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
    margin-left: 46.93%;
    margin-top: 148px;
  }
  .yi {
    width: 100px;
    height: 3px;
    background: linear-gradient(270deg, #fad126, #ff8229);
    border-radius: 0px;
    margin-left: 47.24%;
    margin-top: 19px;
    margin-bottom: 44px;
  }
  .Bighonor {
    display: flex;
    .one {
      width: 100%;
    }
    img {
      width: 100%;
      cursor: pointer;
    }
    .p1 {
      width: 72px;
      height: 19px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      margin: 0 auto;
      margin-bottom: 9px;
      cursor: pointer;
    }
    .p2 {
      width: 128px;
      height: 17px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 30px;
      margin: 0 auto;
      margin-bottom: 74px;
      cursor: pointer;
    }
  }
}
</style>